import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './CodecWarning.module.less';

const CodecWarning = ({
  mediaType,
}) => {
  const [shouldHideCodecWarning, setShouldHideCodecWarning] = useState(false);
  const problemTypes = [
    'video/quicktime',
  ];

  if (!problemTypes.includes(mediaType) || shouldHideCodecWarning) {
     return null;
  }

  return (
    <div className={styles.vpCodecSupportWarning}>
      <svg
        className={styles.vpCodecSupportWarningDismissButton}
        data-testid="closeCodecWarning"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        onClick={() => setShouldHideCodecWarning(true)}
      >
        <path d="M7 6.136l4.457-4.457c0.239-0.239 0.626-0.239 0.864 0s0.239 0.626 0 0.864l-4.457 4.457 4.457 4.457c0.239 0.239 0.239 0.626 0 0.864s-0.626 0.239-0.864 0l-4.457-4.457-4.457 4.457c-0.239 0.239-0.626 0.239-0.864 0s-0.239-0.626 0-0.864l4.457-4.457-4.457-4.457c-0.239-0.239-0.239-0.626 0-0.864s0.626-0.239 0.864 0l4.457 4.457z"/>
      </svg>
      This file may not be available to preview in this web browser until after the media has been processed by our system.
    </div>
  );
}

CodecWarning.propTypes = {
  mediaType: PropTypes.string,
};

export default CodecWarning;



// WEBPACK FOOTER //
// ./src/components/CampaignLanding/CodecWarning.jsx